import React from 'react';

export const Logo: React.FC = () => {
  return (
    <div className="text-center">
      <div className="mx-auto h-16 w-16 relative">
        {/* 회전하는 위성 로고 */}
        <svg viewBox="0 0 48 48" className="w-full h-full">
          <defs>
            <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#667eea"/>
              <stop offset="50%" stopColor="#764ba2"/>
              <stop offset="100%" stopColor="#f093fb"/>
            </linearGradient>
          </defs>
          <circle cx="24" cy="24" r="20" stroke="url(#logoGrad)" strokeWidth="2" fill="none"/>
          <circle cx="24" cy="24" r="8" fill="url(#logoGrad)"/>
          <circle cx="24" cy="10" r="4" fill="#667eea" className="logo-orbit"/>
        </svg>
      </div>
      <h2 className="mt-6 text-3xl font-extrabold text-white drop-shadow-lg">
        GenAI Labs
      </h2>
      <p className="mt-2 text-sm text-gray-400">
        멀티테넌트 SaaS 인증 플랫폼
      </p>
    </div>
  );
};

